import { render, staticRenderFns } from "./WidgetSpace.vue?vue&type=template&id=65abe656&lang=pug"
import script from "./WidgetSpace.vue?vue&type=script&lang=js"
export * from "./WidgetSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports